import { DateTime } from 'luxon';
import { DayNum } from '../../../types';
import { parseStoreHoursString } from '../parseStoreHoursString';
import { StoreDayHours } from '../StoreDayHours';
import { userTimeZone } from '../../../utils/userTimeZone';

export const parseStoreDayHours = (
	open: string,
	close: string,
	timezone: string,
	day: DayNum,
	now: DateTime
): StoreDayHours => {
	const parsedOpen = parseStoreHoursString(open);
	const parsedClose = parseStoreHoursString(close);

	const baseMoment = now
		.setZone(timezone || userTimeZone)
		.set({ second: 0, millisecond: 0, weekday: day });

	const openMoment = baseMoment.set({
		hour: parsedOpen.hours,
		minute: parsedOpen.minutes
	});

	const closeMoment = baseMoment.set({
		hour: parsedClose.hours,
		minute: parsedClose.minutes
	});

	const openCloseDiff = openMoment.diff(closeMoment).milliseconds;

	// if close time is before open time, we interpret this as meaning that the
	// store closes at the specified close time but on the next day.
	if (openCloseDiff > 0) {
		closeMoment.plus({ day: 1 });
	}

	return new StoreDayHours(openMoment, closeMoment);
};
